// frontend/src/askos/mocktest/MockTestsPage.js
//
// Lists published mock tests for the student's accessible subjects.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listMockTests, startMockTest } from '../../api/mockTestApi';

const MockTestsPage = ({ slug }) => {
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [starting, setStarting] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        listMockTests(slug).then(setTests).catch(() => setTests([])).finally(() => setLoading(false));
    }, [slug]);

    const handleStart = async (test) => {
        setStarting(test.id);
        try {
            const res = await startMockTest(slug, test.id);
            navigate(`/samkalp-ias/mock-tests/${test.id}/attempt/${res.attempt_id}`);
        } catch {
            setStarting(null);
        }
    };

    return (
        <div className="subpage">
            <h2>Mock Tests</h2>
            {loading && <p className="empty-note">Loading…</p>}
            {!loading && tests.length === 0 && <p className="empty-note">No mock tests available yet.</p>}

            {tests.map(t => (
                <article key={t.id} className="panel" style={{ marginBottom: 14 }}>
                    <div className="panel-heading">
                        <h3>{t.title}</h3>
                        <span>{t.exam_type}</span>
                    </div>
                    <p className="empty-note">
                        {t.question_count} question{t.question_count === 1 ? '' : 's'} · {t.duration_min} min · {t.total_marks} marks
                        {t.negative_marking > 0 && ` · −${t.negative_marking} per wrong answer`}
                    </p>
                    {t.best_score !== null && t.best_score !== undefined && (
                        <p className="empty-note">Your best score: <strong>{t.best_score}</strong></p>
                    )}
                    <button type="button" className="primary-btn" onClick={() => handleStart(t)} disabled={starting === t.id}>
                        {starting === t.id ? 'Starting…' : 'Start Test'}
                    </button>
                </article>
            ))}
        </div>
    );
};

export default MockTestsPage;
